const liveReporting = {
  en: {
    liveReportingPage: {
      polling: "Polling",
      live: "Live",
      connecting: "Connecting...",
      refresh: "Refresh",
      stations: "{{submitted}} / {{total}} stations",
      unknown: "Unknown",
      resultsCount: "{{count}} results",
      newResult: "New Result Submitted",
      verificationUpdate: "Verification Update",
      processing: "Processing...",
      errors: {
        noToken: "No authentication token",
        subscription: "Pro or Enterprise subscription required for live reporting"
      }
    }
  },
  fr: {
    liveReportingPage: {
      polling: "Interrogation",
      live: "En direct",
      connecting: "Connexion en cours...",
      refresh: "Actualiser",
      stations: "{{submitted}} / {{total}} bureaux de vote",
      unknown: "Inconnu",
      resultsCount: "{{count}} résultats",
      newResult: "Nouveau résultat soumis",
      verificationUpdate: "Mise à jour de la vérification",
      processing: "Traitement en cours...",
      errors: {
        noToken: "Aucun jeton d'authentification",
        subscription: "Un abonnement Pro ou Entreprise est requis pour le suivi en direct"
      }
    }
  }
};

export default liveReporting;
